import 'font-awesome/css/font-awesome.min.css';
import {render} from '@mc/app'

import "./index.scss"

import "url-search-params-polyfill";

render("root");
